<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Documents</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/document/index"
          >Manage Documents</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Create</span>
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-2"></div>
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="createJob">
              <div v-if="message" class="alert alert-success py-2">
                {{ message }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>
              <div class="row mb-3 mx-0">
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Document Title <span class="text-danger">*</span></label
                  ><input
                    v-model="jobTitle"
                    type="text"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                    placeholder="Enter Job Title"
                  />
                </div>
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >People <span class="text-danger">*</span></label
                  ><select
                    v-model="selectedEmployee"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                  >
                    <option value="">Select People</option>
                    <option
                      v-for="employee in employees"
                      :key="employee.id"
                      :value="employee.id"
                    >
                      {{ employee.label }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Document Type <span class="text-danger">*</span></label
                  ><input
                    v-model="metadata.document_type"
                    type="text"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                    placeholder="Enter Document Type"
                  />
                </div>
              </div>

              <div class="card custom_bdr_rds mb-3">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2">
                    <b>Document Files and Links</b>
                  </h6>
                  <div class="table-responsive mb-1">
                    <table
                      style="font-size: small"
                      class="table table-sm table-hover"
                    >
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th>#</th>
                          <th>File Upload</th>
                          <th>Document Link</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rows" :key="row.key">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <input
                              type="file"
                              class="form-control form-control-sm"
                              @change="setFile($event, row)"
                            />
                          </td>
                          <td>
                            <input
                              v-model="row.link"
                              type="url"
                              placeholder="Document link"
                              class="form-control form-control-sm"
                            />
                          </td>
                          <td class="custom-icon">
                            <b-icon
                              @click="removeRow(index)"
                              v-if="rows.length > 1"
                              class="ms-3 me-3 mt-2"
                              width="8"
                              icon="dash-lg"
                              type="button"
                              scale="2"
                            ></b-icon
                            ><b-icon
                              @click="addRow"
                              v-if="index === rows.length - 1"
                              class="mt-2"
                              width="8"
                              icon="plus-lg"
                              type="button"
                              scale="2"
                            ></b-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card custom_bdr_rds mb-3">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2">
                    <b>Mandatory Document Metadata</b>
                  </h6>
                  <div class="row g-2">
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Company <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.company"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Department <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.department"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Branch <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.branch"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Privacy Level <span class="text-danger">*</span></label
                      ><select
                        v-model="metadata.privacy_level"
                        required
                        class="form-control form-control-sm bdr-rad"
                      >
                        <option value="">Select Privacy</option>
                        <option>Public</option>
                        <option>Internal</option>
                        <option>Confidential</option>
                        <option>Restricted</option>
                      </select>
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Project <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.project"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Partner <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.partner"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label"
                        >Template <span class="text-danger">*</span></label
                      ><input
                        v-model="metadata.template"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-md-3">
                      <label class="custom-label">Permission Group</label
                      ><input
                        v-model="metadata.permission_group"
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label">Publisher</label
                      ><input
                        value="Manual Upload"
                        readonly
                        class="form-control form-control-sm bdr-rad bg-light"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label">Status</label
                      ><input
                        :value="documentStatus"
                        readonly
                        class="form-control form-control-sm bdr-rad bg-light"
                      />
                    </div>
                  </div>
                  <h6 class="purchitem mb-2"><b>Add New Meta Fields</b></h6>
                  <div class="table-responsive mb-1">
                    <table
                      style="font-size: small"
                      class="table table-sm table-hover"
                    >
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th>Field Name</th>
                          <th>Field Value</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(field, index) in templateFields"
                          :key="field.key"
                        >
                          <td>
                            <input
                              v-model="field.name"
                              placeholder="Field name"
                              class="form-control form-control-sm"
                            />
                          </td>
                          <td>
                            <input
                              v-model="field.value"
                              placeholder="Field value"
                              class="form-control form-control-sm"
                            />
                          </td>
                          <td class="custom-icon">
                            <b-icon
                              @click="removeTemplateField(index)"
                              v-if="templateFields.length > 1"
                              class="ms-3 me-3 mt-2"
                              width="8"
                              icon="dash-lg"
                              type="button"
                              scale="2"
                            ></b-icon
                            ><b-icon
                              @click="addTemplateField"
                              v-if="index === templateFields.length - 1"
                              class="mt-2"
                              width="8"
                              icon="plus-lg"
                              type="button"
                              scale="2"
                            ></b-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <br /><br>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      employees: [],
      jobTitle: "",
      selectedEmployee: "",
      metadata: {
        company: "",
        department: "",
        document_type: "",
        branch: "",
        privacy_level: "",
        project: "",
        partner: "",
        template: "",
        permission_group: "",
      },
      templateFields: [{ key: Date.now(), name: "", value: "" }],
      rows: [],
      message: "",
      errorMessage: "",
    };
  },
  mounted() {
    this.rows = [this.newRow()];
    this.loadEmployees();
  },
  computed: {
    documentStatus() {
      const required = [
        "company",
        "department",
        "document_type",
        "branch",
        "privacy_level",
        "project",
        "partner",
        "template",
      ];
      return required.every((field) =>
        String(this.metadata[field] || "").trim()
      )
        ? "Published"
        : "Draft";
    },
  },
  methods: {
    newRow() {
      return { key: Date.now() + Math.random(), file: null, link: "" };
    },
    async loadEmployees() {
      try {
        const { data } = await axios.get("/document/employees", {
          headers: { Authorization: "Bearer " + this.token },
        });
        const seen = {};
        this.employees = (data.data || [])
          .filter((item) => {
            const key = item.fin_nric || item.id;
            if (seen[key]) return false;
            seen[key] = true;
            return true;
          })
          .map((item) => ({
            id: item.id,
            label: (item.fin_nric ? item.fin_nric + " - " : "") + item.name,
          }));
      } catch (error) {
        this.errorMessage = "Unable to load employees.";
      }
    },
    addRow() {
      this.rows.push(this.newRow());
    },
    removeRow(index) {
      if (this.rows.length > 1) this.rows.splice(index, 1);
    },
    setFile(event, row) {
      row.file = event.target.files[0] || null;
    },
    addTemplateField() {
      this.templateFields.push({
        key: Date.now() + Math.random(),
        name: "",
        value: "",
      });
    },
    removeTemplateField(index) {
      if (this.templateFields.length > 1) this.templateFields.splice(index, 1);
    },
    async createJob() {
      if (!this.jobTitle.trim() || !this.selectedEmployee) {
        this.errorMessage = "Job Title and Employee are required.";
        return;
      }
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify({
          job_title: this.jobTitle,
          job_description: "",
          employee_id: this.selectedEmployee,
          ...this.metadata,
          template_fields: this.templateFields
            .map(({ name, value }) => ({ name, value }))
            .filter((field) => field.name || field.value),
          details: this.rows.map((row) => ({ link: row.link })),
        })
      );
      this.rows.forEach((row, index) => {
        if (row.file)
          formData.append("assignment_files[" + index + "]", row.file);
      });
      try {
        const { data } = await axios.post("/document/create", formData, {
          headers: { Authorization: "Bearer " + this.token },
        });
        this.message = data.message || "Job assigned successfully.";
        this.errorMessage = "";
        setTimeout(() => this.$router.push("/document/index"), 500);
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to assign job.";
      }
    },
    goBack() {
      this.$router.push("/document/index");
    },
  },
};
</script>
